<template lang="pug">
    div(class="fixed inset-0 z-[100] pointer-events-none")
        transition(
            enter-active-class='transition-opacity ease-linear duration-200',
            enter-class='opacity-0',
            enter-to-class='opacity-100',
            leave-active-class='transition-opacity ease-linear duration-200',
            leave-class='opacity-100',
            leave-to-class='opacity-0'
        )
            div(
                v-if="showFilterMenu"
                class="fixed inset-0 pointer-events-auto"
                @click="closeFilterMenu"
            )
                div(class="w-full h-full bg-black opacity-80")

        transition(
            enter-active-class='right-0 transition ease-in-out duration-200 transform',
            enter-class='right-0 translate-x-full',
            enter-to-class='right-0',
            leave-active-class='right-0 transition ease-in-out duration-200 transform',
            leave-class='right-0',
            leave-to-class='translate-x-full',
        )
            aside(
                v-show="showFilterMenu"
                class="absolute w-[404px] md:w-[480px] pointer-events-auto"
                style="right:0"
            )

                FilterMenu(
                    v-if="menuType === 'filter'"
                    ref="filterMenu"
                    :filterSubMenu="filterSubMenu"
                    @closeFilterMenu="closeFilterMenu"
                    @closeFilterSubMenu="closeFilterSubMenu"
                )
                SortMenu(
                    v-else-if="menuType === 'sort'"
                )

                button(
                    @click="closeFilterMenu"
                    class="absolute top-4 cursor-pointer right-0 -translate-x-full"
                )
                    xIcon(
                        aria-label="close"
                        class="w-4 h-4 text-black fill-current stroke-current"
                    )

                div(
                    class="absolute p-6 pb-12 bottom-0 right-0 w-[404px] md:w-[480px] bg-white border-t border-gray-light"
                )
                    div(class="flex items-center justify-around")

                        button(
                            v-if="menuType === 'filter'"
                            @click="clearRefinements"
                            class="w-full mx-3 bg-gray px-8 py-3 text-light text-center uppercase font-bold"
                        ) Clear All

                        button(
                            @click="closeFilterMenu"
                            class="w-full mx-3 bg-action px-8 py-3 text-light text-center uppercase font-bold"
                        )
                            span(v-if="menuType === 'filter'") Apply
                            span(v-else) Close
</template>

<script>
import SearchComponent from '@/components/search/component'
import xIcon from '@/assets/common/x?inline'
import FilterMenu from './_components/filterMenu'
import SortMenu from './_components/sortMenu'

export default {
    name: 'SlideMenu',
    components: {
        xIcon,
        FilterMenu,
        SortMenu,
    },
    extends: SearchComponent,
    props: {
        showFilterMenu: {
            type: Boolean,
            default: false,
        },
        // String name of the sub menu that is currently open; taken from the catalog data facet.text
        filterSubMenu: {
            type: String,
            default: null, // Possible values 'Category' or a facet.text value
        },
        menuType: {
            type: String,
            default: 'filter', // Possible values 'filter', 'sort'
        },
    },
    head() {
        return {
            htmlAttrs: {
                style: this.showFilterMenu ? 'overflow: hidden' : '',
            },
        }
    },
    methods: {
        closeFilterMenu() {
            // Close all sub menus
            if (this.menuType === 'filter') this.$refs.filterMenu.closeFilterSubMenu()

            this.$emit('onToggle', false)
        },
        closeFilterSubMenu() {
            this.$emit('closeFilterSubMenu')
        },
        clearRefinements() {
            this.$searchContext.clearRefinements()

            const route = {
                name: this.$route.name,
                params: {
                    ...this.$route.params,
                    noUpdateScroll: true,
                },
                query: {
                    ...this.$searchContext.createRouteQuery(),
                },
            }

            this.$push.to(route)

            this.closeFilterMenu()
        },
    },
}
</script>
